GatiServerGame = function () {
  var base = new GatiServer();
  GatiServer.call(this, base);
  this.inFS = false;
  this.fsIndex = 0;
  this.fsWinnings = 0;
  this.fsCount = 0;

  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;
  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.restorePreviousWagersBase = this.restorePreviousWagers;
  this.restorePreviousWagers = this.restorePreviousWagersDerived;
  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this._inBuyABonus = false;
  this._inLuckyBet = false;
  this._localRngSeed = -1;

  this.freeSpinsCostMaxMultiplier;
  this.freeSpinsCostMultiplier;
  this.luckyBetCostMultiplier;

  this._totalWinnings = 0;
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);

GatiServer.prototype.clientReadyToStart = function (cbWhenPlatformReady) {
  var self = this;
  const informGameReady = async (slot) => {
    var readyResponse = await slot.getGameEventsEmitter().gameReady({ defaultBetValue: this._stake / 100 });
    console.log('Gati Platform: Restore Mode set to ' + readyResponse.restoreMode);
    // no longer modal
    messageBus.post('game:modal', { data: 'Platform Ready To Start' });
    self._finishedLoading = true;
    self._isRecoveryGame = readyResponse.restoreMode === 'RESTORE';
    if (self._inRewatchMode || self._inReplayMode || self._isRecoveryGame) {
      gdk.startMinGameTimer(); // we bypass start during recovery so the gdk wont do this for us
      self._isPrePaidGame = true; // Tells setBPL not to show max stake popup, this is a recover game they have already seen this popup
      let stakeInfo = self.restorePreviousWagers();
      self._isPrePaidGame = slot.getWagerHelper().getPrepaidInfo().isPrepaid; //prepaids has a very specifice purpose and this isnt it, so put it back!
      self.initNewGame({ stake: stakeInfo.stake, bpl: stakeInfo.baseStake / self._numLines }, self._isRecoveryGame);

      // now initGame no longer sends balance out because PokerStars doesnt want to the debit until
      // a result has been received so there are no errors, we must do it explicitly in side rewatch/recover/replay
      self.addBalanceEventToQueue();
      self.triggerNextMessage();

      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      self._wagerId = self._latestEngineReponse.wager.wagerid;
      await this._slotGame.getGameEventsEmitter().gameRoundStarted();
      await this._slotGame.getGameEventsEmitter().spinStarted();
      self.addRecoveryToQueue();
      self.triggerNextMessage();
      cbWhenPlatformReady();
      messageBus.postImmediate('common:GameCommitted');
    } else if (readyResponse.restoreMode === 'SKIP') {
      const stakeInfo = self.restorePreviousWagers();
      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      await self.handleSkipWin(self._latestEngineReponse);
      let win = await self.doCollectWinnings();
      gameData.winningsMeter.set(win);
      await self._slotGame.getGameEventsEmitter().gameRoundEnded();
      self._oldBalance = self._balance;
      self._preCommitBalance = self._balance;
      messageBus.postImmediate('common:GameSkipped', stakeInfo);
      self.addBalanceEventToQueue();
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);
      self.triggerNextMessage();
      cbWhenPlatformReady();
    } else {
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);
      cbWhenPlatformReady();
    }
  };

  // stop game interaction just in case the recovery popup will show (we dont know until we have a response from gameReady)
  messageBus.post('game:modal', {
    reason: 'Waiting on Platform',
    data: 'Waiting on Platform',
  });

  informGameReady(this._slotGame);
};

GatiServerGame.prototype.getRandomForGui = function () {
  let rangeExplicit = 32768; // it is the default inside the mersenneTwister but in case they change it I am defining it here
  let r = MarsenneTwister.rand(rangeExplicit);
  let res = r / rangeExplicit;
  return res;
};

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    undefined,
    'LEFT_TOP'
  );
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController('stakeController');
    const maxStake = sc.isMaxStake();
    if (sc.isMaxStake() && !this._inReplayMode && !this._inRewatchMode && !this._isPrePaidGame) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;
  if (gameData.encoreEnabled) {
    newStake *= 1.5;
  }

  this.updateCurrentStake(newStake);
};

GatiServerGame.prototype.restorePreviousWagersDerived = function () {
  let res = this.restorePreviousWagersBase();

  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === 'LUCKYBET_BUY'
  ) {
    this.setDefaultBet(res.baseStake);
  }
  return res;
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  this.addGameConfigToQueueBase(loadData);
  let message = this._messageQueue[0];
  message.buyBonusCost = 100;
  gdk.addConfigValue('AllowBuyBonus', message.slotConfig.gameModes['BONUS_BUY'] ? true : false);

  let configMessage = this._messageQueue[this._messageQueue.length - 1];

  if (configMessage.slotConfig.gameModes.FREESPINS_BUY) {
    // This game mode can be disabled so need to check if exists
    this.freeSpinsCostMultiplier = configMessage.slotConfig.gameModes.FREESPINS_BUY.coinsPerBet / 10;
  }

  gameData.recoveryStake = undefined;
  configMessage.slotConfig.coins = 10; // purely paytable
  configMessage.maxExposure = loadData.settings.slotConfig.MaxExposure;

  this.luckyBetCostMultiplier = configMessage.slotConfig.gameModes.LUCKYBET_BUY.coinsPerBet;

  configMessage.buyBonusCostFreeSpins = this.freeSpinsCostMultiplier;
  configMessage.buyLuckyBet = this.luckyBetCostMultiplier;

  if (configMessage.slotConfig.gameModes['FREESPINS_BUY'] || configMessage.slotConfig.gameModes['LUCKYBET_BUY']) {
    allowBonusBuy = true;
  }

  if (
    loadData.customParameters.buyBonusDisabled === 'yes' ||
    loadData.customParameters.buyBonusDisabled === 'Yes' ||
    loadData.customParameters.license === 'uk' ||
    loadData.customParameters.license === 'fin' ||
    loadData.customParameters.license === 'lt' ||
    loadData.customParameters.license === 'nl' ||
    loadData.customParameters.license === 'de'
  ) {
    allowBonusBuy = false;
  }

  gameData.license = loadData.customParameters.license || 'default';
  gameData.isInReplayMode = this._inReplayMode || false;
  gameData.isInRestoreMode = loadData.mode === 'RESTORE';

  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);

    gameData.recoveryStake = stake;

    if (betData.cmd === 'LUCKYBET_BUY') {
      gameData.recoveryStake *= 1.5;
      gameData.encoreEnabled = true;
    } else {
      gameData.encoreEnabled = false;
    }
  }

  gdk.addConfigValue('AllowBuyBonus', allowBonusBuy ? true : false);
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  this._meta = {};

  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === 'LUCKYBET_BUY') {
      gameData.encoreEnabled = true;
      this._inLuckyBet = true;
      this._meta = {
        name: 'encore',
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === 'FREESPINS_BUY') {
      this._inBuyABonus = true;
      this._meta = {
        name: 'buyABonusFreeSpins',
        value: true,
      };
      break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._inBuyABonus = stakeData.metaData.buyABonus;
  this._inLuckyBet = stakeData.metaData.encore;

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  this._coinValue = 10;
  let stakeController = resourceManager.getController('stakeController');
  let baseStake = stakeController.getBaseStake('default') / 100;

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._inLuckyBet) {
    this._coinValue = 10; // has to be whole number
    request.amount = baseStake * 1.5;
    request.coin = baseStake / this._coinValue;
    request.coins = this.luckyBetCostMultiplier;
    request.cmd = 'LUCKYBET_BUY';
  } else if (this._inBuyABonus) {
    baseStake = stakeController.getBaseStake('FREESPINS_BUY') / 100;
    request.amount = baseStake * this.freeSpinsCostMultiplier;
    request.coin = baseStake / this._coinValue;
    request.cmd = 'FREESPINS_BUY';
  }
};

GatiServerGame.prototype.addFSStartToQueue = function (numFs, initialFs) {
  this.fsWinnings = 0;
  var message = {};
  message.type = 'spinner:FreeSpinsStartEvent';
  message.freeSpinsAwarded = initialFs;
  message.bonusWin = 0;
  message.currentMultiplier = 1;
  message.nextMultiplier = 2;
  this.inGamble = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSDataToQueue = function () {
  let message = {};
  message.type = 'spinner:FreeSpinsDataEvent';
  message.num = this.fsCount + 1;
  message.fsWinnings = this.fsWinnings;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSEndToQueue = function (winnings, isCapped) {
  let message = {};
  message.type = 'spinner:FreeSpinsEndEvent';
  message.fsWinnings = winnings;
  message.totalWinnings = this._totalWinnings;
  message.isBigWin = false;
  message.isCapped = isCapped;
  this.fsWinnings = 0;
  this.inFS = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.shuffleArray = function (array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
};

GatiServerGame.prototype.getSpinData = function (cb, data) {
  let parts = data.Parts;

  if (this.inFS) {
    this.getSpinDataFS(parts[0], cb);
    return;
  }

  let totalWon = 0;
  for (let i = 0; i < parts.length; ++i) {
    let type = parts[i].type;
    this._localRngSeed = -1;
    if (type === 'baseGame') {
      this._finalBaseWinnings = parts[0].winAmount;
      this._localRngSeed = data.ResultId;
      totalWon += this.getSpinDataNormal(parts[i]);
      // base game only, game complete
      if (parts.length === 1) {
        this.addGameCompleteToQueue(totalWon);
      }
    } else if (type === 'gambleEntered') {
      this.addGambleDataToQueue(parts[i]);
      this.inGamble = true;
    } else if (type === 'gambleResult') {
      let won = parts[i].hasWon;
      this.addGambleResultToQueue(won);
      if (!won) {
        this.inGamble = false;
        this.addGameCompleteToQueue(totalWon);
      }
    } else if (type === 'freeSpins') {
      //this.addFSAwardToQueue(parts[i].spins.length);
      this.inGamble = false;
      this.inFS = true;
      this.fsCount = 0;
      this.freeSpins = parts[i].spins;
      this._finalFsWinnings = data.Parts[0].winAmount;
      this._totalWinnings = this._finalBaseWinnings + this._finalFsWinnings;
      this.addFSStartToQueue(parts[i].spins.length, parts[i].initialNumberOfSpins);
    }
  }

  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.processModifiers = function (data, spinEvent) {};

GatiServerGame.prototype.addModifiersToQueue = function (data, cloneReal) {};

GatiServerGame.prototype.hasModifier = function (data) {};

GatiServerGame.prototype.addWinnings = function (winningLinesData, mysteryWildFeature) {
  if (mysteryWildFeature && mysteryWildFeature.isAwarded) {
    mysteryWildFeature.upgradedPayLines.forEach(function (upgradedLine) {
      const upgradedLineId = upgradedLine.winningLine;
      const foundWinningLine = winningLinesData.winningLines.find(function (winningLine) {
        const winningLineId = winningLine.winningLine;
        return winningLineId === upgradedLineId;
      });
      if (foundWinningLine) {
        foundWinningLine.winAmount = upgradedLine.winAmountAfterMultiplier;
      }
    });

    let totalLineWinnings = 0;
    winningLinesData.winningLines.forEach(function (winningLine) {
      return (totalLineWinnings += winningLine.winAmount);
    });
    winningLinesData.totalLineWinnings = totalLineWinnings;
  }

  this.addWinningsToQueue(winningLinesData);
};

GatiServerGame.prototype.removeWildsFromReels = function (reels) {
  const wildId = 9;
  for (let reel = 0; reel < reels.length; ++reel) {
    for (let i = 0; i < reels[reel].symbols.length; ++i) {
      if (reels[reel].symbols[i].value === wildId) {
        reels[reel].symbols[i].value = 0;
      }
    }
  }
};

GatiServerGame.prototype.removeWildsFromAboveBelow = function (message) {
  this.removeWildsFromReels(message.resultPanel.symbolsAbove);
  this.removeWildsFromReels(message.resultPanel.symbolsBelow);
};

GatiServerGame.prototype.addSpinDataToQueue = function (
  event,
  topHitReelBeforeNudge,
  bonuses,
  fullSymbolsOnTopHitReel,
  symbolReelsToNudge,
  isTopHitReelNudged,
  topHitReelAfterNudge,
  mainReelsAfterTopHitUpgrades,
  fishData,
  fishWinAmount,
  finalFreeSpin
) {
  var message = {};
  message.type = 'spinner:SpinEvent';

  message.panelMultiplier = 1;
  message.lines = event.lines;
  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.totalWinnings = event.totalWinnings;
  message.resultPanel = {};
  message.resultPanel.reels = 5;
  message.resultPanel.rectangular = true;
  message.finalFreeSpin = finalFreeSpin;
  if (event.jackpotGame !== undefined && event.jackpotGame === true) {
    message.jackpotGame = true;
  }

  message.resultPanel.reelList = event.reelList;
  message.resultPanel.symbolsAbove = event.symbolsAbove;
  message.resultPanel.symbolsBelow = event.symbolsBelow;

  message.nudgeResultPanel = {};
  message.nudgeResultPanel.reelList = topHitReelBeforeNudge.reelList;
  message.nudgeResultPanel.symbolsAbove = topHitReelBeforeNudge.symbolsAbove;
  message.nudgeResultPanel.symbolsBelow = topHitReelBeforeNudge.symbolsBelow;
  message.fullSymbolsOnTopHitReel = fullSymbolsOnTopHitReel;
  message.symbolReelsToNudge = symbolReelsToNudge;
  message.isTopHitReelNudged = isTopHitReelNudged;
  message.bonuses = bonuses;
  message.topHitReelAfterNudge = topHitReelAfterNudge;
  message.mainReelsAfterTopHitUpgrades = mainReelsAfterTopHitUpgrades;
  message.fishData = fishData;
  message.fishWinAmount = fishWinAmount;

  message.isPrePaidGame = this._isPrePaidGame;

  if (this._localRngSeed !== -1) {
    message.localRng = this._localRngSeed;
  }

  this._messageQueue.push(message);
  return message;
};

GatiServerGame.prototype.getSpinDataGeneric = function (spinEvent, data, freeSpinsActive, cb) {
  let topHitReelBeforeNudge = data.topHitReelBeforeNudge;
  let fullSymbolsOnTopHitReel = data.fullSymbolsOnTopHitReel;
  let topHitReelAfterNudge = data.topHitReelAfterNudge;
  let mainReelsAfterTopHitUpgrades = data.mainReelsAfterTopHitUpgrades;
  let topHitBonuses = data.topHitBonuses;
  let isTopHitReelNudged = false;
  let symbolReelsToNudge = [];
  let isCapped = data.winCapped;
  let finalFreeSpin = false;

  if (freeSpinsActive) {
    if (this.freeSpins.length === this.fsCount) {
      finalFreeSpin = true;
    }

    isCapped = data.isCapped;
    isTopHitReelNudged = data.isTopHitReelNudged;

    for (let i = 0; i < 5; i++) {
      let beforeNudgeReelList = topHitReelBeforeNudge.reelList[i];
      let afterNudgeReelList = topHitReelAfterNudge.reelList[i];
      let changeFound = false;

      for (let j = 0; j < 3; j++) {
        if (beforeNudgeReelList.symbols[j].value !== afterNudgeReelList.symbols[j].value) {
          changeFound = true;
          break;
        }
      }
      if (changeFound) {
        symbolReelsToNudge.push(i);
      }
    }
  } else {
    symbolReelsToNudge = data.nudgeSymbolReelsToNudge;
    if (gameData.encoreEnabled) {
      data.goldenBetReelsToNudge.forEach((item) => {
        if (!symbolReelsToNudge.includes(item)) symbolReelsToNudge.push(item);
      });
    }

    if (symbolReelsToNudge.length !== 0) {
      isTopHitReelNudged = true;
    }
  }

  let fishData = data.fish;
  let fishWinAmount = data.fishWinAmount;

  let updatedResult = this.addSpinDataToQueue(
    spinEvent,
    topHitReelBeforeNudge,
    topHitBonuses,
    fullSymbolsOnTopHitReel,
    symbolReelsToNudge,
    isTopHitReelNudged,
    topHitReelAfterNudge,
    mainReelsAfterTopHitUpgrades,
    fishData,
    fishWinAmount,
    finalFreeSpin
  );

  // Amend sybols for cash fish
  let stake = gameController.getCurrentModeStake(true);
  let winningLinesEvent = data.mainReelsAfterTopHitUpgrades.payLines;

  if (fishData.length > 0) {
    for (let i = 0; i < fishData.length; i++) {
      let baseVal = fishData[i].amount;
      let value = baseVal / stake;
      let sym = updatedResult.resultPanel.reelList[fishData[i].coord.reel].symbols[[fishData[i].coord.row]];

      let temp = data.mainReelsAfterTopHitUpgrades;

      if (value <= 2) {
        // BronzePot
        sym.value = 18;
      } else if (value > 2 && value <= 4) {
        // SilverPot1
        sym.value = 19;
      } else if (value > 4 && value <= 6) {
        // SilverPot2
        sym.value = 20;
      } else if (value > 6 && value <= 12) {
        // GoldPot1
        sym.value = 21;
      } else if (value > 12 && value <= 20) {
        // GoldPot2
        sym.value = 22;
      } else if (value >= 25) {
        // GoldPot3
        sym.value = 23;
      }

      if (sym.value >= 18 && sym.value <= 23) {
        for (let line = 0; line < data.mainReelsAfterTopHitUpgrades.payLines.winningLines.length; line++) {
          if (data.mainReelsAfterTopHitUpgrades.payLines.winningLines[line].symbol.ids[fishData[i].coord.reel] === 9) {
            data.mainReelsAfterTopHitUpgrades.payLines.winningLines[line].symbol.ids[fishData[i].coord.reel] =
              sym.value;
          }
        }
      }
    }
  }

  // change the top hit reel sym
  for (let i = 0; i < 5; i++) {
    let reelList = updatedResult.nudgeResultPanel.reelList[i];

    for (let j = 0; j < 3; j++) {
      let nudgeSym = reelList.symbols[j];

      if (nudgeSym.value === 9) {
        nudgeSym.value = 24;
      }
    }
  }

  if (winningLinesEvent.totalLineWinnings > 0) {
    this.addWinnings(winningLinesEvent, data.mysteryWildFeature);
    const message = this._messageQueue[this._messageQueue.length - 1];
    message.isCapped = isCapped;
  }

  if (freeSpinsActive) {
    this.fsWinnings += data.winAmount;

    if (data.isRetrigger) {
      this.addRetriggerToQueue(8);
    }

    if (this.fsCount < this.freeSpins.length) {
      this.addFSDataToQueue();
    } else {
      this.addFSEndToQueue(this.fsWinnings, data, isCapped);
      this.addGameCompleteToQueue(this.fsWinnings);
      this.inFS = false;
    }

    cb();
    this.triggerNextMessage();
  } else {
    return spinEvent.totalWinnings;
  }
};

GatiServerGame.prototype.getSpinDataNormal = function (data) {
  let spinEvent = data.mainReelsInitial.stopWindow;
  let winningLinesEvent = data.mainReelsAfterTopHitUpgrades.payLines;

  if (!this.validateResponse(spinEvent)) return;
  if (!this.validateResponse(winningLinesEvent)) return;

  this.getSpinDataGeneric(spinEvent, data, false, function () {});
};

GatiServerGame.prototype.getSpinDataFS = function (data, cb) {
  let thisFsOutcome = this.freeSpins[this.fsCount++];
  let spinEvent = thisFsOutcome.mainReelsInitial.stopWindow;

  this.getSpinDataGeneric(spinEvent, thisFsOutcome, true, cb);
};

GatiServerGame.prototype.sendGambleResponseToServer = function (response, cb) {
  if (this._gameNotFullyRecovered) {
    // no need to send state, already done and part of recovery
    this.moveToNextBetData();
    messageBus.postImmediate('Gamble:HandledCommand');
    timerManager.addTimer(500, undefined, cb);
    return;
  }

  this.resetCurrentBetData();

  let self = this;
  let decision = response === 'collect' ? 'COLLECT' : 'RISK';

  let nextStep = self._latestEngineReponse.wager.bets[self._latestEngineReponse.wager.bets.length - 1].step + 1;
  let commands = self._latestEngineReponse.wager.bets[self._latestEngineReponse.wager.bets.length - 1].betdata.cmds;
  let command;

  let preFix = 'GAMBLE_Basic_';
  if (this._inBuyABonus) {
    preFix = 'GAMBLE_BonusBuy_';
  } else if (this._inEncore) {
    preFix = 'GAMBLE_LuckyBet_';
  }

  if (response === 'gamble') {
    command = commands[1];
  } else {
    command = commands[0];
  }

  let playData = {
    cmd: command,
    step: nextStep,
    clientParams: '',
  };

  if (this._forces) {
    this.addCheatToRequest(playData, this._forces);
  }

  const sendCommand = async () => {
    self._latestEngineReponse = await self._slotGame.play(playData);
    self._forces = self.updateForces(self._forces);
    cb();
  };

  sendCommand();
};

GatiServerGame.prototype.addGambleDataToQueue = function (data) {
  var message = {};

  message.type = 'spinner:GambleDataEvent';

  message.nextFreespins = data.nextSpinsCount;
  message.winChance = data.winChance;
  message.loseChance = data.loseChance;
  message.buyABonus = this._inBuyABonus;
  message.buyASuperBonus = this._inBuyASuperBonus;
  message.numFreeSpins = data.currentSpinsCount;

  let self = this;
  message.resultCallback = function (obj, cb) {
    self.sendGambleResponseToServer(obj.response, cb);
  };
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSAwardToQueue = function (freespinsAwarded) {
  var message = {};
  message.type = 'spinner:FreeSpinsAwardEvent';
  message.freeSpinsAwarded = freespinsAwarded;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addGambleResultToQueue = function (won) {
  var message = {};
  message.type = 'game:GambleResultEvent';
  message.won = won;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addRetriggerToQueue = function (count) {
  let message = {};
  message.type = 'spinner:FreeSpinsRetriggerEvent';
  message.num = count;
  this._messageQueue.push(message);
};
